import { realityInfo } from "@/utils/realityInfo";

export const useRegulation = () => {
  const onOpenRegulation = () => {
    if (realityInfo.regulationUrl) {
      window.open(realityInfo.regulationUrl);
    }
  };

  return { onOpenRegulation };
};
